import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from './../types/fileTypes';

export const submitAdmission = (guid: string): Action<any[]> => ({
  type: actionTypes.DOWNLOAD_FILE, ...{ guid },
});
export const previewDocuments = (guid: any, onCallback: any): Action<any[]> => {
  return {
    type: actionTypes.PREVIEW_FILE, ...{ guid, onCallback },
  };
};
export const submitAdmissions = (payload: any): Action<any[]> => ({
  type: actionTypes.DOWNLOAD_ALL_FILES, ...{ payload },
});

export const getBuddimedDocumentTypes = (request: any, onSuccess: any, onError: any): Action<any[]> => ({
  type: actionTypes.BUDDHIMED_FILE_UPLOAD, ...{ request, onSuccess, onError },
});
export const getMobileOtp = (payload: any): Action<any> => {
  return updateAction(actionTypes.VERIFY_MOBILE_NUMBER, payload);
};
export const verifyMobileOtp = (payload: any): Action<any> => {
  return updateAction(actionTypes.VERIFY_MOBILE_OTP, payload);
};
export const getAadharOtp = (payload: any): Action<any> => {
  return updateAction(actionTypes.VERIFY_AADHAR_NUMBER, payload);
};
export const verifyAadhaarOtp = (payload: any): Action<any> => {
  return updateAction(actionTypes.VERIFY_AADHAAR_OTP, payload);
};
export const uploadDoc = (payload: any): Action<any> => {
  return updateAction(actionTypes.UPLOAD_DOC, payload);
};

export const hisFileDownload = (payload: any): Action<any[]> => ({
  type: actionTypes.HIS_FILE_DOWNLOAD, ...{ payload },
});
